 <!-- App Capsule -->
 <div id="appCapsule">
    <div class="section full"> 
        <div class="row float-right mr-5"><a [routerLink] = "" (click)="goToHome()">skip {{counterTimer}}</a></div>      
        <div class="row justify-content-center">
            <img src="assets/img/splash.jpg" alt="" width="500px" height="auto">
        </div>
    </div>
 </div>